import { Injectable } from "@angular/core";
import {
  CustomerResponseRequest,
  CustomerViewResponse,
  ICustomerResponseRequest,
  ServiceLinkClient
} from "src/domain/service-link/serviceLinkClient";

@Injectable({
  providedIn: "root"
})
export class ServiceLinkHttpService {
  private client: ServiceLinkClient = null;

  constructor() {
    this.client = new ServiceLinkClient();
  }

  get(id: string): Promise<CustomerViewResponse> {
    return this.client.customerViewGET(id);
  }

  respond(_proposalId: string, _acceptedItems: number[]): Promise<void> {
    const body = new CustomerResponseRequest({
      proposalId: _proposalId,
      acceptedItemIds: _acceptedItems
    } as ICustomerResponseRequest);

    return this.client.customerViewRespondPOST(body);
  }

  markOpened(proposalId: string) {
    this.client.customerViewOpenedByCustomerPOST(proposalId);
  }
}
